import { render, staticRenderFns } from "./VerifiedEmployee.vue?vue&type=template&id=33d57c39&scoped=true&"
import script from "./VerifiedEmployee.vue?vue&type=script&lang=js&"
export * from "./VerifiedEmployee.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedEmployee.vue?vue&type=style&index=0&id=33d57c39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d57c39",
  null
  
)

export default component.exports